<template>
	<div class="itemer">
		<mt-header title="志愿者" style="background-color: #67d7f9;"></mt-header>
		<div class="mid-banner">
			<div class="mid-itemImg">
				<img src="../../../static/image/index-img.png">
			</div>
		</div>
		<!-- 按钮 -->
		<div class="boxes displayFlex font14">
			<div class="box" @click="recruitClick()">
				<!-- <router-link :to="{name:'articledetail',params:{articleno: 'zhaomu'}}" tag="div"> -->
					<img src="../../../static/image/logo/zhaomu.png">
					<p class="boxName">招募</p>
				<!-- </router-link> -->
			</div>
			<div class="box">
				<router-link to="/honour" tag="div">
					<img src="../../../static/image/logo/rongyu.png">
					<p class="boxName">荣誉</p>
				</router-link>
			</div>
			<div class="box">
				<router-link to="/photowall" tag="div">
					<img src="../../../static/image/logo/zhaopian.png">
					<p class="boxName">照片墙</p>
				</router-link>
			</div>
			<div class="box">
				<router-link to="/volunteer" tag="div">
					<img src="../../../static/image/logo/zhiyuanzhe.png">
					<p class="boxName">志愿者之家</p>
				</router-link>
			</div>
		</div>
		<div class="isolationH f7"></div>
		<div>
			<div class="news-list displayFlex font12">
				<div class="news-ul alignLeft" style="width: 80%;">
					<!-- <p class="ellipse" v-for="(item, index) in items" :key="index"> -->
					<p class="ellipse">
						<span class="news_icon_span">
							<img src="../../../static/image/icon/news-icon.png" height="22">
						</span>
						<router-link :to="{name: 'articledetail',params:{articleno:item.s_recno}}">
							<span class="color_news">
								{{item.s_subject}}
							</span>
						</router-link>
					</p>
				</div>
				<div v-show="items.length>1">
					<router-link to="/info/indexnews">
						<p>
							<span class="moreNews">更多</span>
						</p>
					</router-link>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import {getVolunteerActivities} from '@/api/activity';
	import {pltvolunteerRecruit} from '@/api/article';
	import {Toast} from 'mint-ui';
	export default {
		name: 'ItemLogo',
		data() {
			return {
				item: {},
				items: [],
				now:new Date(),
				params:{
					type: 0,
					page: 1,
					pagesize: 2,
				},
				start:'',
				end:''
			}
		},
		methods:{
			getNews(){
				getVolunteerActivities(this.params).then(res => {
					var _data = res.data;
					if(_data.errcode == '1'){
						this.items = _data.data;
						if(this.items.length>0){
							this.item = this.items[0];
						}
					}
				});
			},
			getPltvo(){
				pltvolunteerRecruit({
					page:1,
					pagesize:15,
					type: 1
				}).then(res=>{
					let info = res.data.data;
					this.start = info['t_starttime'];
					this.end = info['t_endtime'];
				})
			},
			recruitClick(){
				const { start,end,now } = this;
				// let startTime = new Date(start).getTime();
				// let endTime = new Date(end).getTime();
				// let time = new Date().getTime();
				let result = this.compareDate(now,start)
				let result2 = this.compareDate(this.addDates(end,1),now)
				if(result&&result2){
					this.$router.push('volunteer/articledetail/'+ 'zhaomu')
				}else{
					Toast({
						message: '未到开启时间',
						position: 'middle',
						duration: 1000
					});
				}
			},
			compareDate (d1, d2) {
				d1 = typeof (d1) === 'string' ? (new Date(d1.replace(/-/g, '/'))) : d1
				d2 = typeof (d2) === 'string' ? (new Date(d2.replace(/-/g, '/'))) : d2
				return d1 > d2
			},
			addDates (date, days) {
				date = typeof (date) === 'string' ? (new Date(date.replace(/-/g, '/'))) : date
				date.setDate(date.getDate() + days)
				return date
			},
		},
		created() {
			this.getNews();
			this.getPltvo();

		}
	}
</script>

<style lang="less">
	.f7{
		background-color: #f7f7f7;
	}
	.color_news{
		color: #cacaca;
	}
	.itemName {
		margin: 10px 0px;
		padding: 5px;
		background-color: antiquewhite;
	}

	.mid-banner {
		min-height: 148px;
		margin-bottom: 10px;
	}

	.mid-itemImg {
		// width: 84%;
		margin: 0 auto;

		img {
			width: 100%;
			// border-radius: 15px;
		}
	}

	.boxes {
		padding: 0.5em 0;
	}

	.box {
		width: 21%;
		margin: 0 2%;
		color: #595959;

		img {
			max-width: 50%;
		}
	}

	.boxName {
		text-align: center;
		margin: 0.5em 0;
	}

	.news-list {
		margin: 0.3em 0.8em;
		padding: 0.8em 0.5em;
		.news-logo {
			margin-top: 0.2em;
			margin-right: 1em;
		}
		p {
			margin: 0.2em;
			line-height: 1.8em;
			font-size: 13px;
		}
	}
	.news_icon_span{
		vertical-align: text-bottom;
		margin-right: 0.6em
	}
	.moreNews{
		display: inline-block;
		padding: 0.2em 0.5em;
		margin-left: 0.5em;
		color: #d3d3d3;
		letter-spacing: 0.25em;
	}

	@media screen and (min-width:50rem) {
		.bulletin {
			width: 800px;
			margin: 0 auto;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/index/ItemLogo.vue